export default "__VITE_ASSET__339fcbba__"